import { MarkMotif } from "@mineoptics/brand/logo";
import { PageHero } from "@/components/PageHero";
import { PillLink } from "@/components/PillLink";
import { Seo } from "@/components/Seo";
import { useReveals } from "@/lib/motion";
import { CONTACT_EMAIL } from "@/lib/site";

export default function Careers() {
  const scope = useReveals();

  return (
    <div ref={scope}>
      <Seo title="Careers" description="There are no open positions at MineOptics right now. Introduce yourself anyway." path="/careers" />
      <PageHero
        eyebrow="Careers"
        title="No open roles right now."
        lede="We are not hiring at the moment. If you work in mining engineering or build software for it, introduce yourself and we will keep your note."
      >
        <PillLink to={`mailto:${CONTACT_EMAIL}?subject=Introduction`} label="Introduce yourself" variant="accent" arrow />
        <PillLink to="/about" label="About MineOptics" variant="outline" />
      </PageHero>
      <section data-theme="dark" className="flex justify-center overflow-hidden bg-bg pb-24 pt-8 md:pb-40">
        <MarkMotif rings={5} strokeWidth={0.4} className="h-[min(80vw,34rem)] w-[min(80vw,34rem)] text-fg/25" />
      </section>
    </div>
  );
}
